import { tamarackAPI, processApiResponse } from "./Tamarack";

export const FeeDataAPI = {
    async updateFee(updatedFee) {
        const path = `fee`;
        const response = await tamarackAPI.put(path, updatedFee);
        return processApiResponse(response, "put", path);
    },
    async addFee(data) {
        const path = `fee`;
        const response = await tamarackAPI.post(path, data);
        return processApiResponse(response, "post", path);
    },
    async deleteFee(feeId) {
        const path = `fee/${feeId}`;
        const response = await tamarackAPI.delete(path);
        return processApiResponse(response, "delete", path);
    },
};
